import {parseResponse} from "../api"

/**
 * @Grpc("su.unim.mcc.api.CaseServicesService")
 */
export default class CaseServicesService {
  constructor(axios) {
    // todo(egor): add config for domain
    this.axios = axios
  }

  changeRequestedServicesQuantity(req) {
    // todo(egor): add request validation

    return this.axios.post(`/api/case/service-log/change-requested-service-quantity`, req)
      .then((response) => {
        return parseResponse(response)
      })
  }

  changeExecutedServicesQuantity(req) {
    // todo(egor): add request validation

    return this.axios.post(`/api/case/service-log/change-executed-service-quantity`, req)
      .then((response) => {
        return parseResponse(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/services/CaseServiceService.js